import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CaseStatusPage from "./pages/CaseStatusPage";
import "./App.css";

// Claim Lens is heavy — only load its bundle when the user navigates to /photos
const ClaimLensPage = lazy(() => import("./pages/ClaimLensPage"));
const UiicFinalReportPage = lazy(() => import("./pages/UiicFinalReportPage"));
const UiicPortalPage = lazy(() => import("./pages/UiicPortalPage"));
const InstantClaimPage = lazy(() => import("./pages/InstantClaimPage"));
const WorkApprovalPage = lazy(() => import("./pages/WorkApprovalPage"));
const NewReportPage    = lazy(() => import("./pages/NewReportPage"));

const Loader = () => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center",
    height: "100vh", color: "#667085", fontSize: "15px", fontFamily: "Segoe UI, sans-serif" }}>
    Loading…
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/"        element={<HomePage />} />
          <Route path="/status"  element={<CaseStatusPage />} />
          <Route path="/photos"  element={<ClaimLensPage />} />
          <Route path="/uiic"         element={<UiicFinalReportPage />} />
          <Route path="/unitedportal"   element={<UiicPortalPage />} />
          <Route path="/instant-claim" element={<InstantClaimPage />} />
          <Route path="/approval"      element={<WorkApprovalPage />} />
          <Route path="/new-report"    element={<NewReportPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
